import React, { useState, useEffect } from "react";
import { Select, Empty, Tag, Popconfirm } from "antd";
import { PlusOutlined, DeleteOutlined, DisconnectOutlined, ExportOutlined } from "@ant-design/icons";
import { ButtonItem, SelectItem, ModalItem } from "../../../../Components/Items";

const { Option } = Select;


const RackEspacioModal = ({
  modal,
  onCancel,
  profundidades,
  disponibles,
  regionLibre,
  medidasTexto,
  puedeModificar,
  puedeDeshabilitar,
  onColocar,
  onQuitarAcomodo,
  onDesligar,
  onDeshabilitar,
  onCrear,
}) => {
  const [ubicacionElegida, setUbicacionElegida] = useState(undefined);

  // Limpia la selección cada vez que se abre/cambia de espacio.
  useEffect(() => {
    setUbicacionElegida(undefined);
  }, [modal]);

  const titulo = modal
    ? `Espacio  C${modal.columna} · N${modal.nivel}${profundidades > 1 ? ` · P${modal.profundidad}` : ""}`
    : "";

  return (
    <ModalItem title={titulo} visible={!!modal} onCancel={onCancel} width={460} spinning={false}>
      {modal && modal.ubicacion ? (
        <div>
          <div style={{ marginBottom: 8 }}>
            <strong>{modal.ubicacion.clave}</strong>
            {medidasTexto(modal.ubicacion) && (
              <Tag style={{ marginLeft: 8 }} color="geekblue">{medidasTexto(modal.ubicacion)}</Tag>
            )}
          </div>
          {modal.ubicacion.insumos?.length ? (
            <div style={{ display: "flex", flexDirection: "column", gap: 4, marginBottom: 12 }}>
              {modal.ubicacion.insumos.map((i) => (
                <div key={i.insumoId} style={{ display: "flex", justifyContent: "space-between", fontSize: 12 }}>
                  <span>{i.clave} - {i.descripcion}</span>
                  <strong>{i.cantidad}</strong>
                </div>
              ))}
            </div>
          ) : (
            <div style={{ fontSize: 12, color: "#999", marginBottom: 12 }}>Sin existencia registrada</div>
          )}
          <div style={{ display: "flex", gap: 4, justifyContent: "flex-end", flexWrap: "wrap" }}>
            {puedeModificar && (
              <ButtonItem icon={<DisconnectOutlined />} onClick={onQuitarAcomodo}>
                Quitar del acomodo
              </ButtonItem>
            )}
            {puedeModificar && (
              <Popconfirm
                title="¿Desligar esta ubicación del rack? Dejará de pertenecer a este rack (queda disponible para otro)."
                okText="Desligar"
                cancelText="Cancelar"
                onConfirm={onDesligar}
              >
                <ButtonItem naranja icon={<ExportOutlined />}>Desligar del rack</ButtonItem>
              </Popconfirm>
            )}
            {puedeDeshabilitar && (
              <Popconfirm title="¿Deshabilitar esta ubicación?" okText="Sí" cancelText="No" onConfirm={onDeshabilitar}>
                <ButtonItem danger icon={<DeleteOutlined />}>Deshabilitar</ButtonItem>
              </Popconfirm>
            )}
          </div>
        </div>
      ) : (
        <div>
          {!puedeModificar ? (
            <div style={{ fontSize: 12, color: "#8a93a6" }}>No tienes permiso para acomodar ubicaciones.</div>
          ) : (
            <>
              <div style={{ fontSize: 12, color: "#8a93a6", marginBottom: 8 }}>
                Coloca aquí una ubicación (usará las celdas que necesite según su tamaño):
              </div>
              {disponibles.length > 0 ? (
                <div style={{ display: "flex", gap: 8, marginBottom: 12, alignItems: "center" }}>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <SelectItem placeholder="Elige una ubicación..." width="100%" value={ubicacionElegida} onChange={setUbicacionElegida}>
                      {disponibles.map((u) => {
                        const cabeAqui = modal && regionLibre(u, modal.columna, modal.nivel);
                        return (
                          <Option key={u._id} value={u._id} disabled={!cabeAqui} style={!cabeAqui ? { color: "#cf1322" } : undefined}>
                            {u.clave + " - " + u.nombre}{medidasTexto(u) ? ` (${medidasTexto(u)})` : ""}{!cabeAqui ? " · no cabe aquí" : ""}
                          </Option>
                        );
                      })}
                    </SelectItem>
                  </div>
                  <div style={{ flexShrink: 0 }}>
                    <ButtonItem verde type="primary" disabled={!ubicacionElegida} onClick={() => onColocar(ubicacionElegida)}>
                      Colocar
                    </ButtonItem>
                  </div>
                </div>
              ) : (
                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="No hay ubicaciones por colocar" style={{ margin: "8px 0" }} />
              )}
              {onCrear && (
                <ButtonItem  block icon={<PlusOutlined />} onClick={onCrear}>
                  Crear nueva ubicación aquí
                </ButtonItem>
              )}
            </>
          )}
        </div>
      )}
    </ModalItem>
  );
};

export default RackEspacioModal;
